<div>
    <h1 mat-dialog-title>
        <div *ngIf="data">{{'SCORE_PAGE.ADD_TASK_DIALOG.TITLE_MODIFY' | translate}}</div>
        <div *ngIf="!data">{{'SCORE_PAGE.ADD_TASK_DIALOG.TITLE_ADD' | translate}}</div>
    </h1>
    <div mat-dialog-content>
        <form [formGroup]="newTracingActionForm">
            <!-- Texto Libre -->
            <div class="form-group row">
                <label class="col-lg-4 col-form-label">
                    {{'SCORE_PAGE.ADD_TASK_DIALOG.TASK.ACTION_LABEL' | translate}}
                </label>
                <div class="col-lg-8">
                    <mat-form-field class="mat-form-field-fluid">
                        <input matInput
                        #textInput              
                        [placeholder]="'SCORE_PAGE.ADD_TASK_DIALOG.TASK.ACTION_DESCRIPTION' | translate"
                        [formControlName]="'newAction'">    
                        <mat-hint align="end">{{textInput.value.length}} / {{maxLength}}</mat-hint>
                        <!-- errors -->
                        <mat-hint *ngIf="newTracingActionForm.get('newAction').errors?.required">{{'AUTH.VALIDATION.REQUIRED_FIELD' | translate}}</mat-hint>
                        <mat-hint *ngIf="newTracingActionForm.get('newAction').errors?.maxlength">{{'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate | stringFormat: maxLength}}</mat-hint>
                    </mat-form-field>
                </div>       
            </div>
            <!-- Option selection -->
            <div class="form-group row">
                <label class="col-lg-4 col-form-label">
                    {{'SCORE_PAGE.ADD_TASK_DIALOG.EXPIRATION.LABEL' | translate}}
                </label>
                <div class="col-lg-8">
                    <mat-form-field class="mat-form-field-fluid">
                        <mat-label>{{'SCORE_PAGE.ADD_TASK_DIALOG.EXPIRATION.DESCRIPTION' | translate}}</mat-label>
                        <mat-select                 
                            [formControlName]="'expirationDate'">
                            <mat-option 
                                *ngFor="let item of expirationDateDataSource$ | async"
                                [value]="item.id">
                                {{item.description}}
                            </mat-option>
                        </mat-select>
                        <!-- errors -->
                        <mat-hint *ngIf="newTracingActionForm.get('expirationDate').errors?.required">{{'AUTH.VALIDATION.REQUIRED_FIELD' | translate}}</mat-hint>                             
                    </mat-form-field>
                </div>        
            </div>
            <!-- Responsable Role -->
            <div class="form-group row">
                <label class="col-lg-4 col-form-label">
                    {{'SCORE_PAGE.ADD_TASK_DIALOG.RESPONSABLE_ROLE.LABEL' | translate}}
                </label>
                <div class="col-lg-8">
                    <kt-select-input [formGroup]="newTracingActionForm"
                        controlName="responsableRoleId"
                        [items]="responsableRoles$ | async">
                    </kt-select-input>   
                </div>        
            </div>
        </form>
    </div>
    
    <div mat-dialog-actions>
        <button 
            mat-raised-button color="primary" class="btn-return"
            cdkFocusInitial
            (click)="dialogRef.close(null)">
            {{'SCORE_PAGE.ADD_TASK_DIALOG.CANCEL' | translate}}
        </button>
        <button 
            mat-raised-button color="primary"
            [disabled]="!newTracingActionForm.valid"
            (click)="dialogRef.close(getTracingAction())">
            <div *ngIf="data">{{'SCORE_PAGE.ADD_TASK_DIALOG.MODIFY' | translate}}</div>
            <div *ngIf="!data">{{'SCORE_PAGE.ADD_TASK_DIALOG.ADD' | translate}}</div>
        </button>
    </div>

    <!-- GRID LOADER -->
    <div *ngIf="pageLoading$| async" style="max-height: 30px; position: absolute; left: 50%; top: 50%; transform: translate(-50%,-50%);">
            <mat-progress-spinner [diameter]="40" color="primary" mode="indeterminate"></mat-progress-spinner>
    </div>
    <!-- / GRID LOADER -->
</div>
